import React from 'react';
import { A } from 'hookrouter';

const DisplayAreaText = ({ value, urlLink }) => {
    if (urlLink && urlLink.length) {
        return (
            <A className='d-block' title={value} href={urlLink}>
                <div className='disp-multi-line'>{value}</div>
            </A>
        );
    } 
    
    return <div className='disp-multi-line'>{value}</div>;
};

export default DisplayAreaText;
